import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Card } from 'sa-ui';
import he from 'he';
import { decodeText } from 'app/utils/strings';
import { FormattedMessage } from 'react-intl';
import { Row } from 'react-bootstrap';
// import MathJax from 'mathjax3-react';
import { MathJax, MathJaxContext } from 'better-react-mathjax';

import messages from './simulatedQuestionsMessages';
import SimulatedQuestionsAlternativesAnswers from './SimulatedQuestionsAlternativesAnswers';
import SimulatedQuestionsAlternativesFeedback from './SimulatedQuestionsAlternativesFeedback';
import QuestionBadge from './QuestionBadge';

import './SimulatedQuestionsCard.scss';
import SimulatedQuestionLogHistory from './SimulatedQuestionLogHistory';

function parseMedia(text) {
  console.log(process.env.REACT_APP_FILES_API);
  return text ? text.replace(/\/cp\/cpdata\/uploads/g, process.env.REACT_APP_FILES_API) : '';
}

const SimulatedQuestionsCard = (props) => (
  <Card className={classNames('simulated-questions-card', props.className)}>
    <div style={{ maxWidth: props.optional ? 100 : 50 }}>
      <FormattedMessage {...messages.optional}>
        {(txt) => (
          <QuestionBadge
            position={props.optional ? txt : props.position}
            status={props.status}
            selected
          />
        )}
      </FormattedMessage>
    </div>
    {props.text && (
      <MathJaxContext>
        <MathJax>
          <div dangerouslySetInnerHTML={{ __html: parseMedia(decodeText(props.text)) }} />
        </MathJax>
      </MathJaxContext>
    )}
    <div className="mt-3 simulated-questions-card--text">
      {/* <div dangerouslySetInnerHTML={{ __html: parseMedia(decodeText(props.text)) }} /> */}
    </div>
    <SimulatedQuestionsAlternativesAnswers {...props} />
    <SimulatedQuestionsAlternativesFeedback {...props} style={{ marginTop: 15 }} />
    <div style={{ marginTop: 15 }}>
      <strong>
        <FormattedMessage {...messages.generalFeedback} />
      </strong>
    </div>
    {/* <div
      dangerouslySetInnerHTML={{ __html: parseMedia(decodeText(props.feedback)) }}
      className="simulated-questions-card--text"
      style={{ marginTop: 15 }}
    /> */}

    {props.feedback && (
      <div className="simulated-questions-card--text" style={{ marginTop: 15 }}>
        <MathJaxContext>
          <MathJax>
            <div dangerouslySetInnerHTML={{ __html: parseMedia(decodeText(props.feedback)) }} />
          </MathJax>
        </MathJaxContext>
      </div>
    )}

    {props.bloom && (
      <div className="mt-3">
        <FormattedMessage {...messages.bloomTaxanomy} />: {props.bloom}
      </div>
    )}
    <div className="simulated-questions-card--text mt-3">
      {props.catalogings.map((cataloging) => {
        if (cataloging.abilityName || cataloging.abilityDescription) {
          return (
            <div>
              <strong>{cataloging.abilityName}</strong>
              {cataloging.abilityDescription && cataloging.abilityName ? ' - ' : null}
              {cataloging.abilityDescription}
            </div>
          );
        }
        return <div>{cataloging.oficialCatalogingName}</div>;
      })}
    </div>
    {!props.optional && props.validateAccess && (
      <Row className="justify-content-center" style={{ marginTop: 15 }}>
        {Number(props.status) === 1 && !props.completed && (
          <FormattedMessage {...messages.reprove}>
            {(txt) => (
              <button
                className="btn btn-outline-primary btn-outline-primary-rose mr-1"
                onClick={props.onReprove}
              >
                {txt}
              </button>
            )}
          </FormattedMessage>
        )}
        {Number(props.status) === 0 && (
          <FormattedMessage {...messages.approve}>
            {(txt) => (
              <button className="btn btn-success" onClick={props.onApprove}>
                {txt}
              </button>
            )}
          </FormattedMessage>
        )}
      </Row>
    )}
  </Card>
);

SimulatedQuestionsCard.propTypes = {};

SimulatedQuestionsCard.defaultProps = {
  alternatives: [],
  optional: false,
  catalogings: [],
  validateAccess: false,
};

export default SimulatedQuestionsCard;
